import React, { type ReactNode } from 'react';
import { BreadcrumbManager } from '@atlassian/jira-breadcrumbs/src/breadcrumb-manager/index.tsx';
import ProjectSettingsBreadcrumb from '@atlassian/jira-breadcrumbs/src/common-breadcrumbs/project-settings/index.tsx';
import ProjectBreadcrumb from '@atlassian/jira-breadcrumbs/src/common-breadcrumbs/project/index.tsx';
import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types';

type Props = {
	isProjectSimplified: boolean;
	children: ReactNode;
	baseUrl: string;
	projectKey: string;
	projectName: string;
};

const AppDiscoveryProjectSettingsBreadcrumb = ({
	isProjectSimplified,
	children,
	baseUrl,
	projectKey,
	projectName,
}: Props) => (
	<BreadcrumbManager>
		<ProjectBreadcrumb baseUrl={baseUrl} projectKey={projectKey} projectName={projectName}>
			<ProjectSettingsBreadcrumb
				baseUrl={baseUrl}
				projectKey={projectKey}
				projectType={SERVICE_DESK_PROJECT}
				isSimplified={isProjectSimplified}
			>
				{children}
			</ProjectSettingsBreadcrumb>
		</ProjectBreadcrumb>
	</BreadcrumbManager>
);

export default AppDiscoveryProjectSettingsBreadcrumb;
